import {
  Alfaexpress,
  Alfamart,
  Alfamidi,
  AtmBersama,
  BCA,
  BII,
  BJB,
  BNC,
  BNI,
  BRI,
  BSI,
  BTPN,
  CashPayment,
  CIMB,
  Dana,
  Danamon,
  DanDan,
  DKI,
  Doku,
  Gopay,
  Hana,
  Indodana,
  Indomaret,
  Jenius,
  // Kredivo,
  Mandiri,
  Ovo,
  Paypal,
  Permata,
  Qris,
  Sampoerna,
  ShopeePay,
  Sinarmas,
  Stripe,
  Visa,
  Wise,
  Maybank,
} from "assets/images/icons/bank";

export const paymentList = {
  VAList: [
    {
      id: 1,
      label: "BCA Virtual Account",
      value: "bcava",
      icon: BCA,
      fee: 5000,
    },
    {
      id: 2,
      label: "Mandiri Virtual Account",
      value: "mandiriva",
      icon: Mandiri,
      fee: 5000,
    },
    {
      id: 3,
      label: "BNI Virtual Account",
      value: "bniva",
      icon: BNI,
      fee: 5000,
    },
    {
      id: 4,
      label: "BRI Virtual Account",
      value: "briva",
      icon: BRI,
      fee: 5000,
    },
    {
      id: 5,
      label: "Danamon Virtual Account",
      value: "danamonva",
      icon: Danamon,
      fee: 5000,
    },
    {
      id: 6,
      label: "Permata Virtual Account",
      value: "permatabankva",
      icon: Permata,
      fee: 5000,
    },
    {
      id: 7,
      label: "CIMB Virtual Account",
      value: "cimbva",
      icon: CIMB,
      fee: 5000,
    },
    {
      id: 8,
      label: "BII Virtual Account",
      value: "biiva",
      icon: BII,
      fee: 5000,
    },
    {
      id: 9,
      label: "Hana Bank Virtual Account",
      value: "hanabankva",
      icon: Hana,
      fee: 5000,
    },
    {
      id: 10,
      label: "Sampoerna Virtual Account",
      value: "sampoernava",
      icon: Sampoerna,
      fee: 5000,
    },
    {
      id: 11,
      label: "BSI Virtual Account",
      value: "bsiva",
      icon: BSI,
      fee: 5000,
    },
    {
      id: 12,
      label: "BNC Virtual Account",
      value: "bncva",
      icon: BNC,
      fee: 5000,
    },
    {
      id: 13,
      label: "BJB Virtual Account",
      value: "bjbva",
      icon: BJB,
      fee: 5000,
    },
    {
      id: 14,
      label: "Sinarmas Virtual Account",
      value: "sinarmasva",
      icon: Sinarmas,
      fee: 5000,
    },
    {
      id: 15,
      label: "BTPN Virtual Account",
      value: "oy",
      icon: BTPN,
      fee: 5000,
    },
    {
      id: 16,
      label: "Bank DKI Virtual Account",
      value: "bankdkiva",
      icon: DKI,
      fee: 5000,
    },
  ],
  eWalletList: [
    {
      id: 17,
      label: "GOPAY",
      value: "veritrans",
      icon: Gopay,
      fee: 0.0205,
      feetype: "percent",
    },
    {
      id: 18,
      label: "OVO",
      value: "xenditOvo",
      icon: Ovo,
      fee: 0.016,
      feetype: "percent",
    },
    {
      id: 19,
      label: "Dana",
      value: "xendit",
      icon: Dana,
      fee: 0.016,
      feetype: "percent",
    },
    {
      id: 20,
      label: "ShopeePay",
      value: "shopeeXendit",
      icon: ShopeePay,
      fee: 0.015,
      feetype: "percent",
    },
    {
      id: 21,
      label: "Jenius",
      value: "nicepayjeniuspay",
      icon: Jenius,
      fee: 0.0155,
      add: 3000,
      feetype: "percent and fee",
    },
    {
      id: 22,
      label: "QRIS",
      value: "xenditqris",
      icon: Qris,
      fee: 0.00705,
      feetype: "percent",
    },
    {
      id: 23,
      label: "Doku Wallet",
      value: "dokuwallet",
      icon: Doku,
      fee: 0.021,
      feetype: "percent",
    },
  ],
  paylaterList: [
    {
      id: 24,
      label: "Visa / Mastercard",
      value: "ipay88",
      icon: Visa,
      fee: 0.031,
      add: 3000,
      feetype: "percent and fee",
    },
    {
      id: 25,
      label: "Indodana",
      value: "indodana",
      icon: Indodana,
      fee: 0.0105,
      feetype: "percent",
    },
    // {
    //   id: 26,
    //   label: "Kredivo",
    //   value: "ipay88_kredivo",
    //   icon: Kredivo,
    //   fee: 0.0235,
    //   feetype: "percent",
    // },
  ],
  transferBankList: [
    {
      id: 27,
      label: "Transfer Bank BCA",
      value: "bcaapi",
      icon: BCA,
      // fee: 5000,
    },
    {
      id: 28,
      label: "Transfer Bank Mandiri",
      value: "banktransfermandiri",
      icon: Mandiri,
      // fee: 5000,
    },
    {
      id: 29,
      label: "Maybank",
      value: "banktransfermaybank",
      icon: Maybank,
      // fee: 6500,
    },
    {
      id: 30,
      label: "ATM Bersama",
      value: "atmbersamava",
      icon: AtmBersama,
      fee: 5000,
    },
  ],
  storePaymentList: [
    {
      id: 31,
      label: "Alfamart",
      value: "alfamart1",
      icon: Alfamart,
      fee: 5000,
    },
    {
      id: 32,
      label: "Dan-Dan",
      value: "alfamart2",
      icon: DanDan,
      fee: 5000,
    },
    {
      id: 33,
      label: "Alfamidi",
      value: "alfamart3",
      icon: Alfamidi,
      fee: 5000,
    },
    {
      id: 34,
      label: "Alfaexpress",
      value: "alfamart4",
      icon: Alfaexpress,
      fee: 5000,
    },
    {
      id: 35,
      label: "Indomaret",
      value: "veritransindomaret",
      icon: Indomaret,
      fee: 6000,
    },
    {
      id: 36,
      label: "Cash Payment",
      value: "banktransfer2",
      icon: CashPayment,
    },
  ],
  internationalPayment: [
    {
      id: 37,
      label: "Stripe",
      value: "stripe",
      icon: Stripe,
      fee: 0.031,
      add: 9000,
      feetype: "percent and fee",
    },
    {
      id: 38,
      label: "Visa/Mastercard",
      value: "ipay888",
      icon: Visa,
      fee: 0.031,
      add: 3000,
      feetype: "percent and fee",
    },
    {
      id: 39,
      label: "Paypal",
      value: "paypal",
      icon: Paypal,
      fee: 0.06,
      add: 17000,
      feetype: "percent and fee",
    },
    {
      id: 40,
      label: "Wise",
      value: "wise",
      icon: Wise,
      fee: 0.033,
      feetype: "percent",
    },
  ],
};
